import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Button } from '@themesberg/react-bootstrap';
import React, { useMemo } from 'react'
import { Link } from 'react-router-dom';

const notHaveResultYet = <td className="text-warning text-center">{"Chưa có kết quả"}</td>

const cannotGetResult = <td className="text-danger text-center">{"Không lấy được kết quả"}</td>

export const TableRow = (props) => {
  const {
    id,
    resultDate,
    ClassicLotteryChannel,
    LotoTicket,
    totalLotoTickets,
    totalRewaredLotoTickets,
    totalUnRewardLotoTickets,
    result,
    status,
    needsRewardCalculation,
    rewardCalculationStatus,
    onCalculateRewardPress,
    handleAddResult,
  } = props;

  const linkToStatistic = `/loto/statistic-by-ticket?resultId="${id}"`

  const statusState = status
  const resultData = result
  const totalTickets = Number(totalLotoTickets || 0) > 0 ? Number(totalLotoTickets || 0) : LotoTicket.length
  const rewardedTickets = Number(totalRewaredLotoTickets || 0)
  const unRewardedTickets = Number(totalUnRewardLotoTickets || 0)
  const calculatedTickets = rewardedTickets + unRewardedTickets
  const hasResult =
    (Array.isArray(resultData) && resultData.length > 0) ||
    (typeof resultData === 'string' && resultData.trim() !== '') ||
    (resultData && typeof resultData === 'object' && Object.keys(resultData).length > 0)
  const hasPendingRewardCalculation =
    hasResult &&
    totalTickets > 0 &&
    calculatedTickets < totalTickets &&
    [3, 4, 5].includes(Number(statusState))
  const derivedRewardCalculationStatus = useMemo(() => {
    if (!totalTickets) {
      return hasResult ? 'no_tickets' : 'waiting_result'
    }

    if (!hasResult) {
      return 'waiting_result'
    }

    if (hasPendingRewardCalculation) {
      return 'pending_calculation'
    }

    if (rewardCalculationStatus) {
      return rewardCalculationStatus
    }

    if (calculatedTickets >= totalTickets) {
      return 'calculated'
    }

    return 'ready'
  }, [calculatedTickets, hasPendingRewardCalculation, hasResult, rewardCalculationStatus, totalTickets])
  const shouldShowCalculateButton =
    Boolean(needsRewardCalculation) || derivedRewardCalculationStatus === 'pending_calculation'

  const resultTd = useMemo(() => {
    let _resultTd = notHaveResultYet

    if (statusState === 1) {
      _resultTd = 'Chưa có kết quả'
    } else if (statusState === 3 || statusState === 4 || statusState === 5) {
      if (hasResult) {
        _resultTd = (
          <td className="text-center">
            <Button variant='info' onClick={() => handleAddResult(id, resultData)}>
              Xem kết quả
            </Button>
          </td>
        )
      } else {
        _resultTd = cannotGetResult
      }
    }

    return _resultTd
  }, [handleAddResult, hasResult, id, resultData, statusState])

  let newAmount = 0
  let doneAmount = 0

  LotoTicket.forEach(element => {
    if (element.status === 1 || element.status === 2) {
      newAmount += 1
    } else {
      doneAmount += 1
    }
  });

  const statusBadge = useMemo(() => {
    switch (derivedRewardCalculationStatus) {
      case 'pending_calculation':
        return (
          <Badge bg="warning" className="mt-2">
            Chờ tính thưởng
          </Badge>
        )
      case 'calculated':
        return (
          <Badge bg="success" className="mt-2">
            Đã tính xong
          </Badge>
        )
      case 'no_tickets':
        return (
          <Badge bg="secondary" className="mt-2">
            Không có vé
          </Badge>
        )
      case 'ready':
        return (
          <Badge bg="info" className="mt-2">
            Đã có kết quả
          </Badge>
        )
      case 'waiting_result':
      default:
        return (
          <Badge bg="light" text="dark" className="mt-2 border">
            Chờ kết quả
          </Badge>
        )
    }
  }, [derivedRewardCalculationStatus])

  const actionTd = useMemo(() => {
    switch (statusState) {
      case 2:
        return 'Đang chờ kết quả'
      case 3:
      case 4:
      case 5:
        if (LotoTicket.length === 0) {
          return 'Không có vé tính thưởng'
        }

        if (shouldShowCalculateButton) {
          return <Button variant="primary" className="m-1" onClick={() => onCalculateRewardPress(id, props)}>Tính thưởng</Button>
        }

        return (
          <>
            <b className='text-success'>{rewardedTickets}</b> | <b className='text-danger'>{unRewardedTickets}</b><br />
            <Button variant="warning" className="m-1">
              <Link
                target={'_blank'}
                style={{ color: '#fff' }}
                to={linkToStatistic}
                key={id}
              >
                {'Xem chi tiết'}
                <FontAwesomeIcon icon={faExternalLinkAlt} className="ms-1" />
              </Link>
            </Button>
          </>
        )
      default:
        return '';
    }
  }, [
    LotoTicket.length,
    rewardedTickets,
    shouldShowCalculateButton,
    unRewardedTickets,
    id,
    linkToStatistic,
    onCalculateRewardPress,
    statusState,
  ])

  return (
    <tr>
      <td className="text-center">
        {actionTd}
      </td>
      <td className="text-center">
        {ClassicLotteryChannel.name}<br />
        {resultDate}
        <div>{statusBadge}</div>
      </td>
      {resultTd}
      <>
        <td className="text-center">
          <b>Tổng cộng: {totalTickets}</b> <br />
          Mới: {newAmount} <br />
          Đã hoàn thành: {doneAmount}
        </td>
      </>
    </tr>
  );
};
